import { Head, Link } from '@inertiajs/react'
import AdminNav from '../../../components/AdminNav'
import AdminSourceTable from '../../../components/AdminSourceTable'
import { buttonClass, eyebrowClass } from '../../../components/ui'
import type { AdminSource } from '../../../types/admin'

export default function SourcesIndex({ sources }: { sources: AdminSource[] }) {
  return <>
    <Head title="Catalog sources" />
    <AdminNav current="sources" />
    <header className="mb-8 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
      <div><p className={`${eyebrowClass} text-brand`}>Catalog administration</p><h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">The source library.</h1><p className="mt-4 max-w-xl text-base leading-7 text-muted">Follow each document from source text to reviewed claims.</p></div>
      <Link href="/admin/sources/new" className={`${buttonClass} shrink-0`}>Add source</Link>
    </header>
    <p className={`${eyebrowClass} mb-4 text-muted`}>{sources.length} {sources.length === 1 ? 'source' : 'sources'}</p>
    <AdminSourceTable sources={sources} />
  </>
}
